import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { Button, Col, Icon, Row } from '../../Component';
import TextInput from '../../../pages/components/inputs/TextInput';
import { TENANT_PROMOTIONS_CREATE_USSD_CODE_API } from '../../../api/api_data';
import { fail_create_ussd_code, loading_create_ussd_code, reset_create_ussd_code, success_create_ussd_code } from '../../../reducers/auth_tenant/create_ussd_code_Slice';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { UPDATE_USSD_ERROR_MSG, UPDATE_USSD_SUCCESS_MSG } from '../../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { messageToast } from '../../../utils/Utils';
import * as app_consts from "../../../utils/app_consts";


const initialState = { name: "", code: "", gateway_url: "" };

const CreateUssdModal = ({ tenant_info, user_info, isOpen, successFunction, closeModal, data }) => {

 const [open, setOpen] = useState(isOpen);
 const [page_data, setPageData] = useState([]);
 const [loading, setLoading] = useState(false);
 const [error, setError] = useState("");
 const dispatch = useDispatch();
 const [sent_data, setSentData] = useState(data);
 const [submit_loading, setSubmitLoading] = useState(false);
 const [submit_error, setSubmitError] = useState("");
 const [formData, setFormData] = useState(initialState);
 const [employee_data, setEmployeeData] = useState('');
 const [all_employees, setAllEmployees] = useState([]);

 useEffect(() => {
  setError("");
  setSubmitError("");
  setSentData(data);
  setOpen(isOpen);
 }, [isOpen, data]);

 // Handle Change Function
 const handleChange = (e) => {
  setFormData({ ...formData, [e.target.name]: e.target.value });
 };

 const handleCreatedUssdCode = () => {
  setSubmitError('');
  // Dispatch
  dispatch(tenant_auth_actions_helper(loading_create_ussd_code, success_create_ussd_code, fail_create_ussd_code, UPDATE_USSD_ERROR_MSG, UPDATE_USSD_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_PROMOTIONS_CREATE_USSD_CODE_API}`, formData));
 };

 // Listener
 const create_ussd_code_listener = useSelector((state) => state.create_ussd_code.create_ussd_code);

 useEffect(() => {
  if (create_ussd_code_listener.status !== app_consts.IDLE)
  {
   if (create_ussd_code_listener.status === app_consts.LOADING)
   {
    setSubmitLoading(true);
    setSubmitError("");
   } else
   {
    if (create_ussd_code_listener.status === app_consts.FAIL)
    {
     setSubmitError(create_ussd_code_listener.message);
     messageToast(create_ussd_code_listener.message, app_consts.FAIL);
    } else if (create_ussd_code_listener.status === app_consts.SUCCESS)
    {
     messageToast(UPDATE_USSD_SUCCESS_MSG, app_consts.SUCCESS);
     successFunction();
     closeModal();
    }
    setSubmitLoading(false);
    dispatch(reset_create_ussd_code());
   }
  }
 }, [create_ussd_code_listener]);

 return (
  <>
   <Modal isOpen={open} toggle={submit_loading || loading ? "" : closeModal} className="modal-dialog-centered" size={"md "}>
    <ModalHeader toggle={submit_loading || loading ? "" : closeModal}>Create USSD Code</ModalHeader>
    <ModalBody>
     <Row className="g-4">
      <TextInput
       label="Name"
       type="name"
       id_val="name"
       value={formData?.name}
       colSize="6"
       required
       name="name"
       handleChange={handleChange}
      />
      <TextInput
       label="Code"
       type="code"
       id_val="code"
       value={formData?.code}
       colSize="6"
       required
       name="code"
       handleChange={handleChange}
      />
      <TextInput
       label="Gateway URL"
       type="gateway_url"
       id_val="gateway_url"
       value={formData?.gateway_url}
       colSize="6"
       required
       name="gateway_url"
       handleChange={handleChange}
      />
      {submit_error && (
       <div className="mb-3 w-100">
        <Alert color="danger" className="alert-icon">
         <Icon name="alert-circle" /> {submit_error}{" "}
        </Alert>
       </div>
      )}
      <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
       <Button onClick={handleCreatedUssdCode} disabled={submit_loading || !(formData?.name && formData?.code && formData?.gateway_url)} color="primary">
        {submit_loading ? <Spinner size="sm" color="light" /> : "Create USSD Code"}
       </Button>
      </Col>
     </Row>
    </ModalBody>
   </Modal>

  </>
 );
};

export default CreateUssdModal;